import React from "react";
import { useParams } from "react-router-dom";
import ReferralCenter from "../ReferralCenter";

const ReferralCenterPage = () => {
  const { affiliateName } = useParams();
  const decodedAffiliateName = decodeURIComponent(affiliateName);

  return (
    <div className="space-y-6">
      {/* Page Title */}
      <div className="mb-6">
        <p className="text-lg text-gray-300">
          Refer New Affiliates & Earn Bonuses
        </p>
      </div>

      {/* Referral Center Content */}
      <ReferralCenter affiliateName={decodedAffiliateName} />
    </div>
  );
};

export default ReferralCenterPage;
